import {SignUpUserCommand, type SignUpUserInput} from '@perfectpost/perfect-post-common';
import {useMutation} from '@tanstack/react-query';

import {sendOrThrow} from '../../../services/sendOrThrow';
import {authKeys} from '../keys';
import type {MutationUiOptions} from '../../../utils/mutationMeta';

/**
 * Inscription (appel non authentifié, `POST /signup`).
 *
 * Remplace le `send(new SignUpUserCommand(…))` de `Signup`. Un refus est levé en
 * `ApiFailure` : `message` porte le texte brut de l'API (« email already exist »)
 * que la vue reconnaît.
 */
export function useSignUpMutation(options: MutationUiOptions = {}) {
  return useMutation({
    ...options,
    mutationKey: [...authKeys.mutations(), 'signUp'],
    mutationFn: (input: SignUpUserInput): Promise<void> => sendOrThrow(new SignUpUserCommand(input)),
  });
}
